import { useContext, useEffect, useMemo, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";

/** ---------------------------
 *  Local shops config (Option 1)
 *  Add/edit rows here—no more <tr> duplication
 * --------------------------- */
const buildShops = (t, handleBeachcomClick) => ([
  {
    id: "beachcom",
    logoSrc: "https://beachcom.de/img/logo.png",
    altKey: "_market.beachcom_title",
    titleKey: "_market.beachcom_title",
    descriptionKey: "_market.beachcom_description",
    action: { type: "custom", handler: handleBeachcomClick },
  },
  {
    id: "vacationize",
    logoSrc: "https://beachcom.de/img/logo.png",
    altKey: "_market.vacationize_title",
    titleKey: "_market.vacationize_title",
    descriptionKey: "_market.vacationize_description",
    action: { type: "modal", htmlDescriptionKey: "_market.vacationize_description_html", link: "https://beachcom.de/Cmspages/lastMinute" },
  },
  {
    id: "aiakus",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.aiakus_title",
    titleKey: "_market.aiakus_title",
    descriptionKey: "_market.aiakus_description",
    action: { type: "modal", htmlDescriptionKey: "_market.aiakus_description_html", link: "https://www.aiakus.de" },
  },
  {
    id: "sportmeeting_de",
    logoSrc: "https://sportmeeting.de/img/logo.png",
    altKey: "_market.sportmeeting_title",
    titleKey: "_market.sportmeeting_title",
    descriptionKey: "_market.sportmeeting_de_description",
    action: { type: "modal", htmlDescriptionKey: "_market.sportmeeting_description_html", link: "https://www.sportmeeting.de" },
  },
  {
    id: "sportmeeting_com",
    logoSrc: "https://sportmeeting.de/img/logo.png",
    altKey: "_market.sportmeeting_title",
    titleKey: "_market.sportmeeting_title",
    descriptionKey: "_market.sportmeeting_com_description",
    action: { type: "modal", htmlDescriptionKey: "_market.sportmeeting_description_html_1", link: "https://www.sportsmeeting.com" },
  },
  {
    id: "forte_village",
    logoSrc: "/forte.png",
    altKey: "_market.fortvillage_title",
    titleKey: "_market.fortvillage_title",
    descriptionKey: "_market.fortvillage_description",
    action: { type: "modal", htmlDescriptionKey: "_market.fortvillage_description_html", link: "https://forte-village.de/" },
  },
  {
    id: "emirate_de",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.emirate_title",
    titleKey: "_market.emirate_title",
    descriptionKey: "_market.emirate_description",
    action: { type: "modal", htmlDescriptionKey: "_market.emirate_description_html", link: "https://forte-village.de/" },
  },
  {
    id: "sigiriya",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.sigiriya_title",
    titleKey: "_market.sigiriya_title",
    descriptionKey: "_market.sigiriya_description",
    action: { type: "modal", htmlDescriptionKey: "_market.emirate_description_html", link: "https://www.sigiriya.de/" },
  },
  {
    id: "fuerte",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.fuerte_title",
    titleKey: "_market.fuerte_title",
    descriptionKey: "_market.fuerte_description",
    action: { type: "modal", htmlDescriptionKey: "_market.fuerte_description_html", link: "https://fuerte-ventura.de//" },
  },
  {
    id: "reesen",
    logoSrc: "https://aiakus.de/img/logo.png",
    altKey: "_market.reesen_title",
    titleKey: "_market.reesen_title",
    descriptionKey: "_market.reesen_description",
    action: { type: "modal", htmlDescriptionKey: "_market.reesen_description_html", link: "https://www.reesen.lu/" },
  },
]);

const MarketPage = () => {
  const { t } = useContext(LanguageContext);
  const [token, setToken] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", htmlDescription: "", link: "" });

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeIn { from { opacity: 0; transform: scale(0.97); } to { opacity: 1; transform: scale(1); } }
      .modal-body a { color: #004080; font-weight: 500; text-decoration: underline; }
      .modal-body a:hover { color: #0066cc; }
      @media (max-width: 768px) {
        .market-grid { grid-template-columns: 1fr !important; }
        .market-heading { font-size: 1.8rem !important; }
        .market-card h2 { font-size: 1.2rem !important; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/market/token`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        const data = await res.json();
        if (data?.token) setToken(data.token);
      } catch (err) {
        console.error("Failed to fetch market token:", err);
      }
    };
    fetchToken();
  }, []);

  const handleBeachcomClick = () => {
    const url = token ? `https://beachcom.de?token=${token}` : `https://beachcom.de`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openModalWith = (title, htmlDescription, link) => {
    setModalContent({ title, htmlDescription, link });
    setModalOpen(true);
  };

  // Build shops list from local config (rebuilds when language or handler changes)
  const shops = useMemo(() => buildShops(t, handleBeachcomClick), [t, handleBeachcomClick]);

  return (
    <div style={containerStyle}>
      <h1 className="market-heading" style={headingStyle}>{t('_market.heading')}</h1>

      <div className="market-grid" style={gridStyle}>
        <div className="market-card" style={cardStyle}>
          <h2 style={cardHeadingStyle}>{t('_market.forTokenHolders')}</h2>
          <p>{t('_market.forTokenHolders_line1')}</p>
          <p>{t('_market.forTokenHolders_line2')}</p>
        </div>
        <div className="market-card" style={cardStyle}>
          <h2 style={cardHeadingStyle}>{t('_market.forShopOwners')}</h2>
          <p>{t('_market.forShopOwners_line1')}</p>
          <p>{t('_market.forShopOwners_line2')} <a href="mailto:info@teamcoin.de" style={{ color: "#004080", fontWeight: "600" }}>info@teamcoin.de</a></p>
          <p>{t('_market.forShopOwners_line3')}</p>
        </div>
      </div>

      <section>
        <h2 style={sectionHeadingStyle}>{t('_market.steps_heading')}</h2>
        <div style={wizardContainerStyle}>
          {[0,1,2,3].map((i) => (
            <div key={i} style={wizardStepStyle}>
              <div style={wizardCircleStyle}>{i+1}</div>
              <div style={wizardTextStyle}>{t(`_market.steps_list.${i}`)}</div>
              {i < 3 && <div style={wizardFlexLineStyle} />}
            </div>
          ))}
        </div>
      </section>

      <h2 style={sectionHeadingStyle}>{t('_market.shops')}</h2>
      <div className="overflow-x-auto shadow-sm rounded">
        <table className="min-w-full border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-3 py-2 text-left font-semibold text-sm">{t('_market.logo')}</th>
              <th className="border px-3 py-2 text-left font-semibold text-sm">{t('_market.link')}</th>
              <th className="border px-3 py-2 text-left font-semibold text-sm">{t('_market.description')}</th>
            </tr>
          </thead>
          <tbody>
            {shops.map((shop) => (
              <tr key={shop.id}>
                <td className="border px-3 py-2">
                  <img src={shop.logoSrc} alt={t(shop.altKey)} className="h-12" />
                </td>
                <td className="border px-3 py-2">
                  <button
                    onClick={() => {
                      const a = shop.action;
                      if (a.type === "modal") {
                        openModalWith(t(shop.titleKey), t(a.htmlDescriptionKey), a.link);
                      } else if (a.type === "custom") {
                        a.handler();
                      } else if (a.type === "newtab") {
                        window.open(a.link, "_blank", "noopener,noreferrer");
                      }
                    }}
                    className="text-blue-900 font-medium underline"
                  >
                    {t(shop.titleKey)}
                  </button>
                </td>
                <td className="border px-3 py-2">{t(shop.descriptionKey)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} content={modalContent} />
    </div>
  );
};

const Modal = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;
  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <button onClick={onClose} style={modalCloseButtonStyle}>×</button>
        <h3 style={modalTitleStyle}>{content.title}</h3>
        <div style={{ ...modalBodyStyle }} className="modal-body" dangerouslySetInnerHTML={{ __html: content.htmlDescription }} />
        <a href={content.link} target="_blank" rel="noopener noreferrer" style={modalLinkStyle}
          onMouseOver={(e) => (e.target.style.color = '#0066cc')}
          onMouseOut={(e) => (e.target.style.color = '#004080')}>
          Visit Website →
        </a>
      </div>
    </div>
  );
};

/* ---- styles (unchanged) ---- */
const containerStyle = { maxWidth: "1400px", margin: "40px auto", padding: "20px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", color: "#333" };
const headingStyle = { fontSize: "2.2rem", fontWeight: "700", textAlign: "center", marginBottom: "2rem", color: "#004080", letterSpacing: "0.5px" };
const gridStyle = { display: "grid", gap: "20px", gridTemplateColumns: "1fr 1fr", marginBottom: "30px" };
const cardStyle = { backgroundColor: "#f9f9f9", padding: "20px", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", lineHeight: "1.6" };
const cardHeadingStyle = { fontSize: "1.3rem", color: "#004080", marginBottom: "0.5rem" };
const sectionHeadingStyle = { fontSize: "1.6rem", color: "#004080", marginBottom: "1rem", borderBottom: "2px solid #ddd", paddingBottom: "0.3rem" };

const wizardContainerStyle = { display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", margin: "20px 0" };
const wizardStepStyle = { display: "flex", alignItems: "center", flex: "1 1 260px", minWidth: "240px", minHeight: "40px" };
const wizardCircleStyle = { width: "32px", height: "32px", borderRadius: "50%", backgroundColor: "#004080", color: "#fff", fontWeight: 700, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 };
const wizardTextStyle = { marginLeft: "10px", fontSize: "14px", lineHeight: 1.3 };
const wizardFlexLineStyle = { height: "2px", backgroundColor: "#ccc", flex: 1, marginLeft: "12px" };

const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, animation: 'fadeIn 0.3s ease-in-out' };
const modalContentStyle = { backgroundColor: '#fff', padding: '30px 25px', borderRadius: '12px', maxWidth: '550px', width: '90%', maxHeight: '80vh', overflowY: 'auto', position: 'relative', boxShadow: '0 15px 30px rgba(0,0,0,0.15)', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.6', fontSize: '15px', color: '#222' };
const modalCloseButtonStyle = { position: 'absolute', top: '12px', right: '14px', fontSize: '1.3rem', background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontWeight: 'bold' };
const modalTitleStyle = { fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004080' };
const modalBodyStyle = { fontSize: '0.95rem', color: '#333', lineHeight: '1.6' };
const modalLinkStyle = { display: 'inline-block', marginTop: '20px', color: '#004080', fontWeight: '600', textDecoration: 'none', transition: 'color 0.3s ease' };

export default MarketPage;
